import * as React from 'react';
import { memo, SVGProps } from 'react';

function ErrorExclamationFilledIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#E60000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.97501C12.2658 6.97501 12.4854 7.17251 12.5202 7.42877L12.525 7.50001V13.7357C12.525 14.0257 12.2899 14.2607 12 14.2607C11.7342 14.2607 11.5146 14.0632 11.4798 13.807L11.475 13.7357V7.50001C11.475 7.21006 11.7101 6.97501 12 6.97501ZM12 15.75C11.5858 15.75 11.25 16.0858 11.25 16.5C11.25 16.9142 11.5858 17.25 12 17.25C12.4142 17.25 12.75 16.9142 12.75 16.5C12.75 16.0858 12.4142 15.75 12 15.75Z"
        fill="white"
      />
    </svg>
  );
}

const Memo = memo(ErrorExclamationFilledIcon);
export default Memo;
